App.service('DispatcherService', DispatcherService);

DispatcherService.$inject = [
    '$http',
    '$q',
    '$location',
    'localStorageService',
    'DialogService'
];

function DispatcherService($http, $q, $location, localStorageService, DialogService) {
    var _url = '';
    var _method = 'get';
    var _data = {};
    var _params = {};

    this.get = function(uri, data) {
        _method = 'get';
        _params = (data || {});
        _url = uri;

        return this.dispatch();
    };

    this.post = function(uri, data) {
        _method = 'post';
        _data = (data || {});
        _url = uri;

        return this.dispatch();
    };

    this.put = function(uri, data) {
        _method = 'put';
        _data = (data || {});
        _url = uri;

        return this.dispatch();
    };

    this.delete = function(uri, data) {
        _method = 'delete';
        _params = (data || {});
        _url = uri;

        return this.dispatch();
    };

    this.dispatch = function() {
        var p = $q.defer();

        $http(build()).then(function(response) {
            p.resolve(response.data);
        }, function(response) {
            var passable = handleError(response);

            if (passable) {
                p.reject(response.data);
            }
        });

        return p.promise;
    };

    function build() {
        return {
            method: _method.toUpperCase(),
            url:    root + _url,
            data:   _data,
            params: _params,
            headers: {
                'Authorization': 'bearer ' + localStorageService.get('token')
            }
        };
    }

    function handleError(response) {
        var _continue = true;

        switch (response.status) {
            case (400 || '400'):
                DialogService.error(response.data.title, response.data.message);
                break;

            case (401 || '401'):
                DialogService.error('Session Expired', 'Looks like your session expired');

                _continue = false;

                $location.path('/');
                break;

            case (422 || '422'):
                DialogService.error('Validation Errors', response.data.message[0]);
                break;

            case (500 || '500'):
                DialogService.error('Whoops!', 'There was a problem processing the last request, please try again');
                break;

            case (555 || '555'):
                DialogService.error('Whoops!', 'Looks like our site is currently experience some issues, please try again in a few moments');

                _continue = false;

                $location.path('/site-down');
                break;

            case (423 || '423'):
                DialogService.error(
                    response.data.title,
                    'Click the button below to go to Survey Monkey and re-authorize the application',
                    function() {
                        location.href = response.data.message;
                    }
                );

                _continue = false;
                break;

            default:
                DialogService.error('Error', response.data);
                break;
        }

        return _continue;
    }
}